<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 授权管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>退款审核</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.accountType" placeholder="请选择账户类型" @change="queryAccountTypeChange">
					<el-option key="" label="请选择账户类型" value=""></el-option>
					<el-option key="0" label="渠道账户" value="0"></el-option>
					<el-option key="1" label="客户账户" value="1"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.companyId" placeholder="请选择公司" filterable>
					<el-option key="" label="请选择公司" value=""></el-option>
					<el-option v-for="item in queryCompanysKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="accountType" label="账户类型" width = "100px" :formatter="accountTypeFormat"></el-table-column>
				<el-table-column prop="accountCompanyName" label="账户名称"></el-table-column>
				<el-table-column prop="operate" label="操作类型" width = "120px" :formatter="operateTypeFormat"></el-table-column>
				<el-table-column prop="balanceBefore" label="操作前余额" width = "120px"></el-table-column>
				<el-table-column prop="amount" label="申请退款金额" width = "120px"></el-table-column>
                <el-table-column prop="operateInfo" label="凭证信息" width = "160px">
					<template slot-scope="scope" v-if="scope.row.operateInfo">
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in scope.row.operateInfo.split(',')">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="imgPrefix+payReceiptItem"
									:preview-src-list="[imgPrefix+payReceiptItem]"
								v-if="scope.row.operate==2&&scope.row.operateInfo"></el-image>
							</div>
						</el-tooltip>
                    </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat" width = "100px"></el-table-column>
				<el-table-column prop="createTime" label="申请时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-check"
                            @click="handlePass(scope.$index, scope.row)"
							v-if = "controll['pass'] && scope.row.accountType==1&&scope.row.reviewerId === undefined"
                        >通过</el-button>
						<el-button
                            type="text"
                            icon="el-icon-close"
							class="red"
                            @click="handleRefuse(scope.$index, scope.row)"
							v-if = "controll['refuse'] && scope.row.accountType==1&&scope.row.reviewerId === undefined"
                        >拒绝</el-button>
						<!-- <el-button
                            type="text"
                            icon="el-icon-check"
                            @click="handlePass(scope.$index, scope.row)"
							v-if = "controll['pass'] && scope.row.accountType==0&&scope.row.operateInfo!=undefined&&scope.row.reviewerId === undefined"
                        >确认</el-button> -->
						<el-button
                            type="text"
                            icon="el-icon-close"
                            @click="handleRefuse(scope.$index, scope.row)"
							v-if = "controll['refuse'] && scope.row.accountType==0&&scope.row.operateInfo==undefined&&scope.row.reviewerId === undefined"
                        >撤销</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="退款申请详情" :visible.sync="showVisible" width="50%">
			<el-form ref="refund" :model="refund" label-width="120px">
				<el-descriptions class="margin-top" title="" :column="2" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							账户类型
						</template>
						{{accountTypeFormat(null, null, refund.accountType)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							操作类型
						</template>
						{{operateTypeFormat(null, null, refund.operate)}}
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							名称
						</template>
						{{refund.accountCompanyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							操作前余额
						</template>
						￥{{refund.balanceBefore}}
					</el-descriptions-item><el-descriptions-item>
						<template slot="label">
							退款金额
						</template>
						￥{{refund.amount}}
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							退款申请说明
						</template>
						{{refund.remark}}
					</el-descriptions-item>
					<el-descriptions-item  span="2" v-if="refund.operateInfo">
						<template slot="label">
							退款凭证
						</template>
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in refund.operateInfo.split(',')">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="imgPrefix+payReceiptItem"
									:preview-src-list="[imgPrefix+payReceiptItem]"
								v-if="refund.operate==2&&refund.operateInfo"></el-image>
							</div>
						</el-tooltip>
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							状态
						</template>
						{{statusFormat(refund, null, refund.status)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							审核人
						</template>
						{{refund.reviewerName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							审核时间
						</template>
						{{refund.reviewerTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							确认人
						</template>
						{{refund.withdrawConfirmName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							确认时间
						</template>
						{{refund.withdrawConfirmTime}}
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							确认备注
						</template>
						{{refund.withdrawConfirmRemark}}
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showVisible = false">关 闭</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchRefundAccountRecordPages, passAccountRecord, refuseAccountRecord, getAllCustomerKV, getChannelKV, getAccountRecord } from '../../../api/index';
export default {
    name: 'refund-check',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
			pageTotal: 0,
            tableData: [],
			queryCompanysKV:[],
			showVisible:false,
			refund:{},
			imgPrefix:"/image",
			controll:{}
        };
		
    },
    created() {
		this.controll = getControll("refund-check");
        this.getData();
    },
    methods: {	
		operateTypeFormat(row, column, cellValue) {
			let operateTypeConfig = {"0":"撤单", "1":"订货", "2":"退款"};
			return operateTypeConfig[cellValue];
		},
		accountTypeFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"渠道账户", "1":"客户账户"};
			return arrivalStatusConfig[cellValue];
		},
		queryAccountTypeChange(value) {
			if(value == "" || value == undefined) {
				this.queryCompanysKV = [];
				return;
			}
			let execQuery = value === "0"?getChannelKV:getAllCustomerKV;
			execQuery().then(res => { 
				if (res.code == 0 ) {
					this.queryCompanysKV = res.data;
				} else {
					this.$message.error("获取公司信息失败");
				}
            });
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchRefundAccountRecordPages(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 审核
        handlePass(index, row) {
			let typeName=row.accountType===0?'收到':'通过';
            this.$confirm('确定' + typeName + row.accountCompanyName + '的' + row.amount + '元退款吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					passAccountRecord(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('复核操作成功');
							this.getData();
						} else {
							this.$message.error(`复核操作失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		// 取消审核
        handleRefuse(index, row) {
		    let typeName=row.accountType===0?'撤销':'拒绝';
            this.$confirm('确定' + typeName + row.accountCompanyName + '的' + row.amount + '元退款申请吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					refuseAccountRecord(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success(typeName + '操作成功');
							this.getData();
						} else {
							this.$message.error(typeName + '操作失败！' + res.message);
						}
					});
                })
                .catch(() => {});
        },
		handleShow(index, row) {
			getAccountRecord(row.id).then(res => {
				if (res.code == 0) {
					this.refund = res.data;
					this.showVisible = true;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		statusFormat(row, column, cellValue) {
			let status;
			let operateTypeConfig
			if (row.accountType==0) {
				status = "确认中...";
				operateTypeConfig = {"0":"已确认", "1":"已撤销"};
			} else {
				status = "处理中...";
				operateTypeConfig = {"0":"通过", "1":"拒绝"};
			}
			return operateTypeConfig[cellValue]==undefined?status:operateTypeConfig[cellValue];
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.warning {
    color: #ffaa00;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
